// extracted by mini-css-extract-plugin
export default {"drawerBody":"ExperienceDetails_drawerBody__HHRZE"};